<template>
	<div class="container">
		<div class="register_con">
			<div class="register_user">
				<div class="user_input">
					<div class="input_icon">
						<img src="../assets/images/icon_user.png" alt=""/>
					</div>
					<input v-model="forgetData.phone" type="text" maxlength="11" placeholder="请输入手机号" placeholder-style="color:#9c9c9c"/>
				</div>
                <div class="user_input">
					<input v-model="forgetData.code" type="number" maxlength="11" placeholder="请输入验证码" placeholder-style="color:#9c9c9c"/>
                    <div class="get_code" @click="getCode">{{codeText}}</div>
				</div>
				<div class="user_input">
					<div class="input_icon">
						<img src="../assets/images/icon_password.png" alt=""/>
					</div>
					<input v-model="forgetData.password" type="password" placeholder="请输入新密码" placeholder-style="color:#9c9c9c"/>
				</div>
                <div class="user_input">
					<div class="input_icon">
						<img src="../assets/images/icon_password.png" alt=""/>
					</div>
					<input v-model="passwordAgain" type="password" placeholder="请再次输入新密码" placeholder-style="color:#9c9c9c"/>
				</div>
				<div class="register_now" @click="forgetForm">确定重置</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { getVerifyCode } from '@/api/login.js'
    import { findPassword } from '@/api/login.js'
	export default {
		name: 'register',
		data () {
			return {
                forgetData:{
                    token: '',
                    phone: '',
                    password: '',
                    code: ''
                },
                passwordAgain: '',
                codeText: '获取验证码',
                getcodeFlag: false,
                timeNum: 60
			}
		},
		computed: {
			
		},
		created () {
			
		},
		mounted () {
            this.forgetData.token = window.localStorage.getItem("token");
		},
		methods: {
            //获取验证码
            getCode(){
                let that = this;
                if(this.getcodeFlag){
                    return false
                }
                let phone_num = this.forgetData.phone;
				if(phone_num == ''){
					this.$message.error('请输入手机号！');
					return
				}else{
					if(!this.checkPhone(phone_num)){
                        return false;
                    }
                }
                this.getcodeFlag = true;
                let data = {
                    phone: phone_num
                }
                getVerifyCode(data).then(res =>{
                    console.log(res);
                    if(res.code != 0){
                        that.$message.error('发送失败，请重试');
                    }
                })
                let countDown = setInterval(function(){
					that.timeNum = that.timeNum - 1;
                    that.codeText = that.timeNum + 's';
					if(that.timeNum == 0){
                        that.getcodeFlag = false;
                        that.timeNum = 60;
                        that.codeText = '获取验证码';
						clearInterval(countDown)
					}
				},1000)
            },
			forgetForm(){
				let that = this;
				let phone_num = this.forgetData.phone;
				if(phone_num == ''){
					this.$message.error('请输入手机号！');
					return
				}else{
					if(!this.checkPhone(phone_num)){
                        return false;
                    }
                }
                if(this.forgetData.code == ''){
					this.$message.error('请输入验证码！');
					return
				}
				if(this.forgetData.password == ''){
					this.$message.error('请输入密码！');
					return
                }
                if(this.forgetData.password != this.passwordAgain){
					this.$message.error('两次输入的密码不一致！');
					return
                }
                let data = this.forgetData;
                findPassword(data).then(res =>{
                    if(res.code == 0){
                        that.$message.success('密码修改成功，请重新登录！');
                        setTimeout(function(){
                            that.$router.push({ path: "/" });
                        },1000)
                    }else{
                        that.$message.error(res.message);
                    }
                })
			},
			//校验手机号
			checkPhone(phone){ 
				if(!(/^1[3456789]\d{9}$/.test(phone))){ 
					this.$message.error("请填写正确的手机号!");  
					return false; 
				} else{
					return true
				}
			}
        }
	}
</script>

<style>
	.container{
        width: 100%;
        height: 100%;
		position: relative;
		background-image: url('../assets/images/bg.jpg');
		background-size: 100% 100%;
		z-index: 10;
    }
	.register_con{
		width: 488px;
		height: 540px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -270px;
		margin-left: -244px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		background-image: url('../assets/images/login_bg.png');
		background-size: 100% 100%;
	}
	.register_types{
		width: 296px;
		height: 35px;
		margin-top: 68px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between
	}
	.register_types .register_type{
		height: 35px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}
	.register_types .register_type .type_word{
		width: 80px;
		height: 34px;
		line-height: 34px;
		font-size: 18px;
		color: #313330;
	}
	.register_types .register_type .type_line{
		width: 80px;
		height: 1px;
		background-color: #000000;
	}
	.register_code{
		width: 236px;
		height: 280px;
		margin-top: 50px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
	}
	.register_code .code_pic{
		width: 236px;
		height: 236px;
		background-color: #ffffff;
	}
	.register_code .code_word{
		width: 236px;
		height: 24px;
		margin-top: 12px;
		line-height: 24px;
		color: #525252;
		font-size: 16px;
	}
	.register_user{
		width: 365px;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
	}
	.register_user .user_input{
		width: 365px;
		height: 52px;
		background-color: #ffffff;
		margin-top: 30px;
		border-radius: 52px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start
	}
	.register_user .user_input .input_icon{
		width: 20px;
		height: 24px;
		margin-left: 20px;
	}
	.register_user .user_input input{
		width: 200px;
		height: 24px;
		margin-left: 30px;
		font-size: 14px;
		color: #333333;
		background: rgba(0,0,0,0);
		background:none;  
		outline:none;  
		border:none;
	}
	.register_user .user_input input:focus{  
		border:none;
	}
    .register_user .get_code{
        width: 100px;
        height: 28px;
		font-size: 14px;
        line-height: 28px;
		color: #6d6d6d;
        border: 1px solid #6d6d6d;
        border-radius: 5px;
        text-align: center;
        cursor: pointer;
    }
	.register_user .forget_btn{
		width: 365px;
		height: 26px;
		margin-top: 15px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 28px;
	}
	.register_user .forget_btn p{
		width: 65px;
		height: 26px;
		line-height: 26px;
		text-align: right;
		font-size: 12px;
		color: #9a9899;
		cursor: pointer;
	}
	.register_user .register_now{
		width: 365px;
		height: 48px;
        cursor: pointer;
        background-color: #fe0100;
		border-radius: 48px;
		line-height: 48px;
		text-align: center;
		color: #ffffff;
        font-size: 16px;
        margin-top: 30px;
    }
</style>
